import React from "react";
import styles from "./ScrollableCardCircle.module.css";
import { Link, useNavigate } from "react-router-dom";

/** REUSEABLE COMPONENTS */
import CategoryTitle from "../../reusable/categoryTitle/CategoryTitle";
import CategorySeeAllButton from "../../reusable/categorySeeAll/CategorySeeAll";

const ScrollableCardCircle = ({ data, title, category_id ,category_type}) => {
  const navigate = useNavigate();
  const handleClick = (id) => {
    navigate(`/music/detail/${category_type}/${id}`);
  };


  return (
    <div className={`w-full`}>
      <div className="my-4 flex justify-center">
      <CategoryTitle title={title}/>
      {/* <span className="float-right text-yellow-400">See All</span> */}
      <CategorySeeAllButton to={`/music/see_all/${category_id}/${category_type}`} />
      </div>
      <div className={`${styles.imageContainer} pr-2`}>
        {data.map((data, index) => (
         <div className={`${styles.scrollableImage} my-4`} key={index} 
         onClick={() => handleClick(data.id)}
         >
          <img
            src={data.image}
            key={index}
            alt={`Image ${index + 1}`}
            className={`${styles.image} rounded-lg`}
          />
          <span className="block text-sm mt-2 truncate pb-1 text-center">{data.title}</span>
          {/* <span className="block text-xs mt-2 truncate">{data.desc}</span> */}
         </div>
        ))}
      </div>
    </div>
  );
};

export default ScrollableCardCircle;
